export const carouselConstants = {
    GET_CAROUSEL_CONTENT_ACTION_REQUEST: 'GET_CAROUSEL_CONTENT_ACTION_REQUEST',
    GET_CAROUSEL_CONTENT_ACTION_SUCCESS: 'GET_CAROUSEL_CONTENT_ACTION_SUCCESS',
    GET_CAROUSEL_CONTENT_ACTION_FAILURE: 'GET_CAROUSEL_CONTENT_ACTION_FAILURE'
}